module.exports = __webpack_public_path__ + "img/car-motor.e6f2ce80.png";